export const NOTIFICATION_TYPES = {
    SUCCESS: {
        icon: 'CheckIcon',
        color: 'bg-green-400',
        time: 'now',
    },
    INFO: {
        icon: 'BellIcon',
        color: 'bg-primary-300',
        time: 'now',
    },
    WARNING: {
        icon: 'ExclamationTriangleIcon',
        color: 'bg-yellow-400',
        time: 'now',
    },
    ERROR: {
        icon: 'XCircleIcon',
        color: 'bg-red-400',
        time: 'now',
    },
};

const createNotificationTemplate = (type, overrides) => ({
    ...NOTIFICATION_TYPES[type],
    ...overrides,
});

export const NOTIFICATION_TEMPLATES = {
    CREATE_CHAT: createNotificationTemplate('SUCCESS', {
        title: 'Chat created',
        description: 'New chat has been created',
        icon: 'ChatBubbleLeftRightIcon',
    }),
    EDIT_CHAT: createNotificationTemplate('INFO', {
        title: 'Chat renamed',
        description: 'Chat has been renamed',
        icon: 'PencilIcon',
    }),
    ARCHIVE_CHAT: createNotificationTemplate('INFO', {
        title: 'Chat archived',
        description: 'Chat has been archived',
        icon: 'ArchiveBoxIcon',
    }),
    DELETE_CHAT: createNotificationTemplate('WARNING', {
        title: 'Chat deleted',
        description: 'Chat has been deleted.',
        icon: 'TrashIcon',
    }),
    COPY_CHATID: createNotificationTemplate('INFO', {
        title: 'Chat ID copied',
        description: 'Chat ID has been copied to the clipboard ready to share',
        icon: 'ShareIcon',
    }),
    CHANGE_SOURCE: createNotificationTemplate('INFO', {
        title: 'Source changed',
    }),
    COPY_PROMPT_CHATMESSAGE: createNotificationTemplate('INFO', {
        title: 'Message copied',
        description: 'Message has been copied to the clipboard',
        icon: 'ClipboardIcon',
    }),
    COPY_PROMPT_CHATIMAGE: createNotificationTemplate('INFO', {
        title: 'Image copied',
        description: 'Image has been copied to the clipboard',
        icon: 'PhotoIcon',
    }),
    COPY_URL_CHATIMAGE: createNotificationTemplate('INFO', {
        title: 'URL copied',
        description: 'URL has been copied to the clipboard',
        icon: 'LinkIcon',
    }),
    COPY_CODE: createNotificationTemplate('INFO', {
        title: 'Code snippet copied',
        description: 'Code snippet has been copied to the clipboard',
        icon: 'CodeBracketIcon',
    }),
    DOWNLOAD_PROMPT_CHATIMAGE: createNotificationTemplate('INFO', {
        title: 'Image downloaded',
        description: 'Image has been downloaded',
        icon: 'ArrowDownTrayIcon',
    }),
    COPY_PROMPT_TABLE: createNotificationTemplate('INFO', {
        title: 'Table copied',
        description: 'Table has been copied to the clipboard',
        icon: 'TableCellsIcon',
    }),
    CHAT_MODE_CHANGE: createNotificationTemplate('WARNING', {
        title: 'Chat mode',
        description: 'Chat mode has been changed to [[MODE]]',
        icon: 'ChatBubbleLeftRightIcon',
    }),
    CHAT_MESSAGE_LIKED: createNotificationTemplate('INFO', {
        title: 'Message liked',
        description: 'Message has been liked',
        icon: 'HandThumbUpIcon',
    }),
    CHAT_MESSAGE_DISLIKED: createNotificationTemplate('INFO', {
        title: 'Message disliked',
        description: 'Message has been disliked',
        icon: 'HandThumbDownIcon',
    }),
    FEEDBACK: createNotificationTemplate('INFO', {
        title: 'Feedback',
        description: 'Feedback submitted. Thank you!',
        icon: 'PaperAirplaneIcon',
    }),
    INDEXED_SOURCES_PREFERENCES: createNotificationTemplate('SUCCESS', {
        title: 'Indexed sources',
        description: 'Preferences have been saved',
    }),
    EXPORT_PROMPT_TABLE: createNotificationTemplate('INFO', {
        title: 'Table export for Excel',
        description: 'Table has been exported as an Excel file',
        icon: 'TableCellsIcon',
    }),
    PREVENT_SEND_AS_UPLOADING: createNotificationTemplate('WARNING', {
        title: 'File still uploading',
        description: 'Try again when upload is complete',
        icon: 'ClockIcon',
    }),
    FILE_UPLOAD_COMPLETE: createNotificationTemplate('SUCCESS', {
        title: 'Upload complete',
        description: 'Document[s] uploaded successfully',
        icon: 'CheckIcon',
    }),
};
